<template>
  <div></div>
</template>

<script>
import global from '../../utils/global'
import axios from 'axios'

export default {
  components: {},
  data () {
    return {
    }
  },
  mounted() {
    this.userLogin()
  },
  methods: {
    //登录
    userLogin() {
      let vm = this
      let fid = this.$route.query.code
      axios({
        method: 'post',
        url: global.restUrl + '/api/web/user/v1.0/oauth',
        data: {
          code: fid
        }
      }).then(function (response) {
        let success = response.data.success
        if(success) {
          let data = response.data.data
          //console.log(data)
          localStorage.setItem("user", JSON.stringify(data))
          vm.$router.push("/")
        }
      });
    },
    
  }
}
</script>
